<template>
    <div class="auth-status-wrapper">
        <!-- 未认证 -->
        <template v-if="shopInfo.auth_status === -1">
            <!-- <span>主体：</span> -->
            <span class="weirenzheng">
                <i class="iconfont iconyiguanbi" style="color: #FF6565 " />
                <span>未认证</span>
            </span>
            <span class='goRenzheng' @click="goToApprove">去认证>></span>
        </template>
        <!-- 认证中 -->
        <template v-if="shopInfo.auth_status === 0">
            <div class="fx-v-center shenheing">
                <span>主体：</span>
                <i class="iconfont icontiming"/>
                <span>审核中</span>
            </div>
        </template>
        <!-- 认证通过 -->
        <template v-if="shopInfo.auth_status === 1">
            <div class="renzhengpass text-popper" v-textPopper>
                <span>主体：</span>
                <span class="enterprise" v-if="shopInfo.auth_type === 0">企业认证</span>
                <span class="enterprise" v-if="shopInfo.auth_type === 1">个人认证</span>
                <span>{{ shopInfo.auth_name }}</span>
            </div>
        </template>
        <!-- 认证拒绝 -->
        <template v-if="shopInfo.auth_status === 2">
            <span>主体：</span>
            <span class="has-refuse">已拒绝</span>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        shopInfo: {
            type: Object,
            default: () => {}
        }
    },

    methods: {
        
        goToApprove() {
            const params = {
                shop_id: this.shopInfo.id,
                shop_type: 'new_ls',
                shop_name: this.shopInfo.shop_name,
                shop_super_admin_passport_id: this.shopInfo.creator.passport_id
            }
            const path = '/#/main/shopApply'
            window.location.href = process.env.VUE_APP_CENTER_DOMAIN + path + this.queryify(params)
        },

        queryify(params){
            const arr = []
            Object.entries(params).forEach(([k, v]) => {
                if (v != null) {
                    // null和undefined会被忽略
                    arr.push(`${k}=${v}`)
                }
            })
            return `?${arr.join('&')}`
        }
    }
}
</script>

<style lang="scss" scoped>
.auth-status-wrapper {
    display: inline-flex;
    align-items: center;
    width: 200px;
}

.weirenzheng {
    // height: 30px;
    display: flex;
    align-items: center;

    span {
         color: #e51c23;
        margin-left: 2px;
    }
}

.shenheing {
    color: #009688;

    i {
        font-size: 20px;
        margin-right: 4px;
    }

    span {
        flex: none;
    }
}

.has-refuse {
    color: #ee5b5b;
}

.enterprise {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 64px;
        height: 24px;
        margin-right: 4px;
        color: #FAAD14;
        background: rgba(250, 173, 20, .2);
    }

.goRenzheng {
    margin-left: 8px;
    color: #67A1F9;
    cursor: pointer;
}
</style>
